import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../DependencyHelper";
import formStyles from "../NewLineForms.module.scss";
import styles from "./XdsForm.module.scss";

const XdsForm = ({ formContent, formName, fieldValues, onChangeHandler }) => {
  const handleChange = (event, name, value) => {
    onChangeHandler(event, name, value, formName);
  };

  return (
    <CustomContainer
      className={`${formStyles["main-container"]} ${styles["main-container"]} `}
    >
      <Form.Row className={`${formStyles["main-row"]} ${styles["main-row"]}`}>
        <>
          {formContent.map((item, index) => (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              key={index}
              className={`${formStyles["form-group"]} ${styles["form-group"]}`}
              controlId={`validationFormxf${index + 101}`}
            >
              <Form.Label
                className={`${formStyles["form-radio-main-label"]}`}
                id={`validationFormxf${index + 101}-label`}
              >
                {index + 1}. {item.question}
              </Form.Label>
              {item?.answers?.answerDocument.map((subItem, subIndex) => (
                <Form.Check
                  custom
                  key={subIndex}
                  className={`${formStyles["form-radio-label"]}`}
                  id={`validationFormxf${index + 101}-op-${subIndex + 1}`}
                >
                  <Form.Check.Input
                    name={subItem.answerID}
                    type="radio"
                    checked={
                      fieldValues[item.productAuthenticationQuestionID] ==
                      subItem.answerID
                        ? true
                        : false
                    }
                    onChange={e =>
                      handleChange(
                        e,
                        item.productAuthenticationQuestionID,
                        subItem.answerID
                      )
                    }
                  />
                  <Form.Check.Label>{subItem.answer}</Form.Check.Label>
                </Form.Check>
              ))}
            </Form.Group>
          ))}
        </>
      </Form.Row>
    </CustomContainer>
  );
};

XdsForm.propTypes = {
  formContent: PropTypes.array,
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  onChangeHandler: PropTypes.func,
};

XdsForm.defaultProps = {
  fieldValues: {},
};

export default XdsForm;
